import dayjs from "dayjs";
import { FC } from "react";
import { ITicket } from "../../../interfaces/reservations/Reservations.types";
import { cx } from "../../../utils/classnames";

const station = (name: string) => name.replace("Stacioni", "").trim();

// One row per ticket (a leg, for all of its passengers). Locked when the whole booking goes.
const TicketChecklist: FC<{
  tickets: ITicket[];
  selectedIds: number[];
  locked: boolean;
  /** The ticket the dialog was opened from; it takes the focus. */
  initialTicketId?: number;
  onToggle: (ticketId: number) => void;
}> = ({ tickets, selectedIds, locked, initialTicketId, onToggle }) => (
  <ul className="flex flex-col gap-1">
    {tickets.map((ticket) => {
      const checked = selectedIds.indexOf(ticket.ticketId) >= 0;
      return (
        <li key={ticket.ticketId}>
          <label
            className={cx([
              "flex items-center gap-3 rounded-md border px-3 py-2",
              !locked && "cursor-pointer",
              checked ? "border-gray-300 bg-white" : "border-gray-200 bg-gray-50 text-gray-500"
            ])}
          >
            <input
              type="checkbox"
              className="w-4 h-4 border-gray-300 rounded"
              checked={checked}
              disabled={locked}
              autoFocus={!locked && ticket.ticketId === initialTicketId}
              onChange={() => onToggle(ticket.ticketId)}
            />
            <span className="flex-1 min-w-0 break-words">
              {station(ticket.departureStationName)} → {station(ticket.arrivalStationName)}
              <span className="block text-xs text-gray-500">
                {dayjs(ticket.journeyDate).format("DD MMM YYYY")} · {ticket.operatorName}
              </span>
            </span>
          </label>
        </li>
      );
    })}
  </ul>
);

export default TicketChecklist;
